import { SwitchSize } from "components/atoms/Switch";
import { COLOR_SYSTEM } from "components/design/design-system";
import styled from "styled-components";

interface SwitchWrapperProps {
  size: SwitchSize;
  isActive: boolean;
}

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;

  & > * + * {
    margin-left: 12px;
  }
`;

export const SwitchButton = styled.label<SwitchWrapperProps>`
  display: inline-block;
  width: ${({ size }) => {
    switch (size) {
      case "Large":
        return "68px";
      case "Medium":
        return "48px";
      case "Small":
      default:
        return "36px";
    }
  }};
  height: ${({ size }) => {
    switch (size) {
      case "Large":
        return "36px";
      case "Medium":
        return "28px";
      case "Small":
      default:
        return "20px";
    }
  }};
  background-color: ${({ isActive }) =>
    isActive ? COLOR_SYSTEM.get("Skyblue")?.[400] : COLOR_SYSTEM.get("Gray")?.[200]};
  position: relative;
  border-radius: 36px;
  transition: background-color 0.3s;
  cursor: pointer;

  input {
    display: none;
  }
`;

export const Slider = styled.span<SwitchWrapperProps>`
  width: ${({ size }) => {
    switch (size) {
      case "Large":
        return "20px";
      case "Medium":
        return "12px";
      case "Small":
      default:
        return "8px";
    }
  }};
  height: ${({ size }) => {
    switch (size) {
      case "Large":
        return "20px";
      case "Medium":
        return "12px";
      case "Small":
      default:
        return "8px";
    }
  }};
  display: block;
  // x : unActive: y 값이랑 동일, active:
  // y : 1/2 * (container-height) - label의 반지름 길이
  transform: ${({ isActive, size }) => {
    const container = {
      Large: {
        width: 68,
        height: 36,
      },
      Medium: {
        width: 48,
        height: 28,
      },
      Small: {
        width: 36,
        height: 20,
      },
    };

    const radius = {
      Large: 10,
      Medium: 6,
      Small: 4,
    };

    const { width, height } = container[size];
    const posY = height / 2 - radius[size];
    const posX = isActive ? width - (2 * radius[size] + posY) : posY;
    return `translate(${posX}px, ${posY}px)`;
  }};
  background-color: white;
  border-radius: 50%;
  transition: transform 0.3s;
`;
